import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { IShippingCompanyApi } from './base/shippingCompanyApi';
import { Result } from '../models/common/resultResponse';
import { GetShippingCompaniesResponse } from '../models/response/packingTrackingHistoryResponse';

const baseRoute: string = 'ShippingCompany';

export class ShippingCompanyApi extends IShippingCompanyApi {
  getShippingCompany(
    guidProcurementSupplier: string,
    guidPackingTrackingDelivery: string
  ): Promise<AxiosResponse<Result<GetShippingCompaniesResponse[]>>> {
    return api.get(`${baseRoute}/getshippingcompanybusinesshour`, {
      params: {
        guidProcurementSupplier: guidProcurementSupplier,
        guidPackingTrackingDelivery: guidPackingTrackingDelivery
      }
    });
  }
}
